import type { ReactNode } from 'react';

interface SectionTitleProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

/**
 * Luxury SectionTitle component with serif font and gold underline gradient.
 *
 * Features:
 * - DM Serif Display font, italic (font-serif italic)
 * - Gold color (#d4a853) for text
 * - Gradient underline to right (bg-gradient-to-r from-gold to-transparent)
 * - Flex layout with icon support
 */
export function SectionTitle({
  children,
  icon,
  className = '',
}: SectionTitleProps) {
  return (
    <h3
      className={`
        font-serif text-xl font-normal italic text-gold
        mb-6 flex items-center gap-4 tracking-wide
        ${className}
      `}
    >
      {icon && <span className="text-gold">{icon}</span>}
      <span>{children}</span>
      <span className="flex-1 h-px bg-gradient-to-r from-slate-dark to-transparent" />
    </h3>
  );
}
